import { useCircuitsQuery } from "../circuits/CircuitQueries";
import { Filter } from "../shared/QueryHelpers";
import { getLapCount } from "./pressureUtils";

export const useGetTireTestLapCount = (tireTest) => {
    // Calculate lap count.
    // Distance per Stint / Distance of the circuit
    const { status: statusCircuit, data } = useCircuitsQuery({
        ...Filter.from({ label: tireTest.circuit }),
    });
    if (statusCircuit === "success" && data.list[0] && data.list[0].distance) {
        return getLapCount(data.list[0]?.distance) ?? 0;
    }
};
